import http from "./http";
import { BASE_URL } from "./quartixApi";

// A tela espera por isto; API pendurada nao pode segurar o botao.
const TIMEOUT_MS = 4000;

// "ok" | "denied" | "unavailable": quem chama precisa distinguir credencial
// errada de API fora do ar (ou de um 429 do nginx).
//
// "denied" cobre os DOIS casos - e-mail fora do userdb e keycode errado - e a
// tela mostra uma mensagem so para os dois. O passo do e-mail nao verifica
// nada: ele so avisa, pelo `sendLoginAlert`.
export async function checkKeycode(email, keycode) {
  try {
    const { data } = await http.post(
      `${BASE_URL}/login_check`,
      { email, keycode },
      { timeout: TIMEOUT_MS }
    );

    if (!data || data.success !== true) return "unavailable";

    return data.data && data.data.authenticated === true ? "ok" : "denied";
  } catch (e) {
    return "unavailable";
  }
}

export default checkKeycode;
